var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6C10.75 6 11 6.25 11 6.5C11 6.78125 10.75 7 10.5 7H7V10.5C7 10.7812 6.75 11 6.5 11C6.21875 11 6 10.7812 6 10.5V6.5C6 6.25 6.21875 6 6.5 6H10.5ZM6 15.5C6 15.25 6.21875 15 6.5 15C6.75 15 7 15.25 7 15.5V19H10.5C10.75 19 11 19.25 11 19.5C11 19.7812 10.75 20 10.5 20H6.5C6.21875 20 6 19.7812 6 19.5V15.5ZM19.5 6C19.75 6 20 6.25 20 6.5V10.5C20 10.7812 19.75 11 19.5 11C19.2188 11 19 10.7812 19 10.5V7H15.5C15.2188 7 15 6.78125 15 6.5C15 6.25 15.2188 6 15.5 6H19.5ZM19 15.5C19 15.25 19.2188 15 19.5 15C19.75 15 20 15.25 20 15.5V19.5C20 19.7812 19.75 20 19.5 20H15.5C15.2188 20 15 19.7812 15 19.5C15 19.25 15.2188 19 15.5 19H19V15.5Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/area-icon.eb4a2e8cd3dfab0bbab2a447a94b7213.svg";
export { ForwardRef as ReactComponent };